import { useSelector } from 'react-redux';
import { selectDefaultCreationEnvironment } from '../../components/pages/environments/environmentsReducer';
import { selectRefreshVersion } from '../../reducers/global/globalReducer';
import { useCallback, useEffect, useRef } from 'react';
import { useFetchGlobal } from './useFetchGlobal';
import { useSweepParams } from '../../navigation-utils/useSweepParams';

const useGlobalDataFetcherListener = () => {
  const { fullCrmOrgId: paramsCrmOrgId } = useSweepParams<{ crmOrgId: string }>();
  const currentDefaultCreationEnvId = useSelector(selectDefaultCreationEnvironment)?.id;
  const crmOrgId = paramsCrmOrgId ?? currentDefaultCreationEnvId;
  const refreshVersion = useSelector(selectRefreshVersion(crmOrgId ?? ''));
  const lastFetchedVersionRef = useRef(0);
  const { fetchGlobal } = useFetchGlobal();

  const fetchData = useCallback(
    (crmOrgId: string) => {
      fetchGlobal({ crmOrgId });
    },
    //fetchGlobal has to be in the dep array, or it is called with outdated properties (SWEEP-4670)
    [fetchGlobal],
  );

  //run on mount and every crmOrgId change
  useEffect(() => {
    // Reset the version ref so that the new org's refreshVersion (which may be
    // lower than the previous org's) is not incorrectly skipped.
    lastFetchedVersionRef.current = 0;
    if (crmOrgId) {
      fetchData(crmOrgId);
    }
  }, [crmOrgId, fetchData]);

  //run when refreshVersion increments
  useEffect(() => {
    if (crmOrgId && refreshVersion > lastFetchedVersionRef.current) {
      lastFetchedVersionRef.current = refreshVersion;
      fetchData(crmOrgId);
    }
  }, [crmOrgId, refreshVersion, fetchData]);
};

export default useGlobalDataFetcherListener;
